/**
 * Created by minimus on 20.07.2015.
 */
(function($) {
  const ejLocale = (options.locale.changeLocale) ? options.locale.locale : 'en-US';
  const localeStrings = options.strings;
  const startDate = options.periods[options.period].start;
  const endDate = options.periods[options.period].end;
  const intervalType = (options.period < 20) ? 'days' : 'months';
  const labelFormat = ((options.period < 20) ? ((ejLocale === 'ru-RU') ? 'd MMM' : 'MMM dd') : 'MMM, yyyy');
  const subTitle = (options.view === 'all') ? '' : ((options.owner === 'all') ? localeStrings.advertisers : localeStrings.advertiser + ': ' + options.owner);
  const chartURI = ajaxurl + ((options.view === 'sold') ? '?action=load_chart_data' : '?action=load_chart_data_all') + '&sam_pro_nonce=' + options.samProNonce;
  const gridURI = ajaxurl + ((options.view === 'sold') ? '?action=load_grid_data' : '?action=load_grid_data_all') + '&sam_pro_nonce=' + options.samProNonce;
  const childGridURI = ajaxurl +
    ((options.view === 'sold') ? `?action=load_grid_child_data&start=${startDate}&end=${endDate}&owner=${options.owner}&period=${options.period}` :
      `?action=load_grid_child_data_all&start=${startDate}&end=${endDate}&owner=${options.owner}&period=${options.period}`) + '&sam_pro_nonce=' + options.samProNonce;
  const pieURI = ajaxurl + ((options.view === 'sold') ? '?action=load_pie_data' : '?action=load_pie_data_all') + '&sam_pro_nonce=' + options.samProNonce;
  const pie2URI = ajaxurl + ((options.view === 'sold') ? '?action=load_pie_data_2' : '?action=load_pie_data_2_all') + '&sam_pro_nonce=' + options.samProNonce;
  const pieParams = `&item=${options.item}&start=${startDate}&end=${endDate}&period=${options.period}&owner=${options.owner}`;

  $(document).ready(function() {
    function getAdChart(aid, pid) {
      const adChartURI = ajaxurl + '?action=load_ad_chart_data' + '&sam_pro_nonce=' + options.samProNonce;
      const adChartParams = `&aid=${aid}&pid=${pid}&start=${startDate}&end=${endDate}&period=${options.period}`;
      const dmAdChart = ej.DataManager({
        url: adChartURI + adChartParams,
        requestType: 'json',
        adaptor: new ej.UrlAdaptor()
      });
      const queryAdChart = new ej.Query();
      const promise = dmAdChart.executeQuery(queryAdChart);

      promise.done((e) => {
        const chart = $('#ad-chart').ejChart({
            locale: ejLocale,
            enableCanvasRendering: true,
            canResize: true,
            isResponsive: true,
            theme: ej.datavisualization.Chart.Theme.FlatLight,
            title: {
              text: options.periods[options.period].title,
              font: {
                fontFamily: '"Open Sans",sans-serif',
                fontWeight: 'bold'
              }
            },
            primaryXAxis: {
              valueType:"datetime",
              intervalType: intervalType,
              labelFormat: labelFormat
            },
            commonSeriesOptions: {
              tooltip: {
                visible:true ,
                format: "#series.name#: #point.y#"
              }
            },
            series: [
              {
                name: localeStrings.impressions,
                type: 'column',
                dataSource: dmAdChart,
                xName: 'mdate',
                yName: 'hits',
                query: e.query, //queryAdChart,
                marker: {
                  dataLabel: {
                    visible: true,
                    textPosition: "top",
                    fill: "#FF7777",
                    verticalTextAlignment: "top",
                    offset: 20,
                    shape: "rectangle",
                    font: {color: "white"}
                  }
                }
              },
              {
                name: localeStrings.clicks,
                type: 'column',
                dataSource: dmAdChart,
                xName: 'mdate',
                yName: 'clicks',
                query: e.query, //queryAdChart,
                marker: {
                  dataLabel: {
                    visible: true,
                    textPosition: "top",
                    fill: "#ffd45a",
                    verticalTextAlignment: "top",
                    offset: 20,
                    shape: "rectangle",
                    font: {color: "white"}
                  }
                }
              }
            ]
          }).data("ejChart");
        chart.redraw();
      });

      return false;
    }

    const adChartDialog = $('#chart-dialog').ejDialog({
        width: 950,
        allowDraggable: true,
        enableModal: true,
        showOnInit: false
      }).data('ejDialog');

    $('#close-chart').on('click', (e) => {
      e.preventDefault();
      adChartDialog.close();
    });

    const dmChart = ej.DataManager({
      url: chartURI,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const queryChart = new ej.Query()
      .addParams('item', options.item)
      .addParams('start', startDate)
      .addParams('end', endDate)
      .addParams('owner', options.owner)
      .addParams('period', options.period);
    const chart = $('#chart').ejChart({
      locale: ejLocale,
      enableCanvasRendering: true,
      canResize: true,
      isResponsive: true,
      //enable3D: true,
      theme: ej.datavisualization.Chart.Theme.FlatLight,
      title: {
        text: options.periods[options.period].title,
        font: {
          fontFamily: '"Open Sans",sans-serif',
          fontWeight: 'bold'
        },
        subTitle: {
          text: subTitle,
          font: {
            size: "14px",
            fontFamily: '"Open Sans",sans-serif',
            fontWeight: 'bold'
          }
        }
      },
      primaryXAxis: {
        valueType: "datetime",
        intervalType: intervalType,
        labelFormat: labelFormat
      },
      commonSeriesOptions: {
        tooltip: {
          visible: true,
          format: "#series.name#: #point.y#"
        }
      },
      series: [
        {
          name: localeStrings.impressions,
          type: 'column',
          dataSource: dmChart,
          xName: 'mdate',
          yName: 'hits',
          query: queryChart,
          enableSmartLabels: true,
          marker: {
            dataLabel: {
              visible: true,
              textPosition: "top",
              fill: "#FF7777",
              verticalTextAlignment: "top",
              offset: 10,
              shape: "rectangle",
              font: {color: "white"}
            }
          }
        },
        {
          name: localeStrings.clicks,
          type: 'column',
          dataSource: dmChart,
          xName: 'mdate',
          yName: 'clicks',
          query: queryChart,
          marker: {
            dataLabel: {
              visible: true,
              textPosition: "top",
              fill: "#ffd45a",
              verticalTextAlignment: "top",
              offset: 20,
              shape: "rectangle",
              font: {color: "white"}
            }
          }
        }
      ]
    });

    const dmGrid = ej.DataManager({
      url: gridURI,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmChildGrid = ej.DataManager({
      url: childGridURI,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const gridColumns = (options.view === 'sold') ? [
      {field: 'pid', headerText: localeStrings.adId, isPrimaryKey: true, textAlign: ej.TextAlign.Right, width: 70},
      {field: 'title', headerText: localeStrings.name},
      {field: 'hits', headerText: localeStrings.impressions, textAlign: ej.TextAlign.Right, width: 100},
      {field: 'clicks', headerText: localeStrings.clicks, textAlign: ej.TextAlign.Right, width: 80},
      {field: 'income', headerText: localeStrings.income, textAlign: ej.TextAlign.Right, width: 100},
      {field: 'cpm', headerText: 'CPM', textAlign: ej.TextAlign.Right, width: 100},
      {field: 'cpc', headerText: 'CPC', textAlign: ej.TextAlign.Right, width: 100},
      {field: 'ctr', headerText: 'CTR', textAlign: ej.TextAlign.Right, width: 100}
    ] : [
      {field: 'pid', headerText: localeStrings.adId, isPrimaryKey: true, textAlign: ej.TextAlign.Right, width: 70},
      {field: 'title', headerText: localeStrings.name},
      {field: 'hits', headerText: localeStrings.impressions, textAlign: ej.TextAlign.Right, width: 100},
      {field: 'clicks', headerText: localeStrings.clicks, textAlign: ej.TextAlign.Right, width: 80},
      {field: 'sold', headerText: localeStrings.status, textAlign: ej.TextAlign.Center, width: 100}
    ];
    const childGridColumns = (options.view === 'sold') ? [
      {field: 'pid', headerText: 'Place ID', isPrimaryKey: true, visible: false},
      {field: 'aid', headerText: localeStrings.adId, textAlign: ej.TextAlign.Right, width: 70},
      {field: 'title', headerText: localeStrings.name},
      {field: 'hits', headerText: localeStrings.impressions, textAlign: ej.TextAlign.Right, width: 100},
      {field: 'clicks', headerText: localeStrings.clicks, textAlign: ej.TextAlign.Right, width: 80},
      {field: 'income', headerText: localeStrings.income, textAlign: ej.TextAlign.Right, width: 100},
      {field: 'cpm', headerText: 'CPM', textAlign: ej.TextAlign.Right, width: 100},
      {field: 'cpc', headerText: 'CPC', textAlign: ej.TextAlign.Right, width: 100},
      {field: 'ctr', headerText: 'CTR', textAlign: ej.TextAlign.Right, width: 100}
    ] : [
      {field: 'pid', headerText: 'Place ID', isPrimaryKey: true, visible: false},
      {field: 'aid', headerText: localeStrings.adId, textAlign: ej.TextAlign.Right, width: 70},
      {field: 'title', headerText: localeStrings.name},
      {field: 'hits', headerText: localeStrings.impressions, textAlign: ej.TextAlign.Right, width: 100},
      {field: 'clicks', headerText: localeStrings.clicks, textAlign: ej.TextAlign.Right, width: 80}
    ];
    const grid = $('#grid').ejGrid({
      dataSource: dmGrid,
      query: new ej.Query()
        .addParams('item', options.item)
        .addParams('start', startDate)
        .addParams('end', endDate)
        .addParams('owner', options.owner)
        .addParams('period', options.period),
      locale: ejLocale,
      allowTextWrap: true,
      allowPaging: true,
      pageSettings: {pageSize: options.itemsPerPage},
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Single,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      columns: gridColumns,
      childGrid: {
        dataSource: dmChildGrid,
        queryString: "pid",
        locale: ejLocale,
        allowTextWrap: true,
        allowSelection: true,
        selectionType: ej.Grid.SelectionType.Single,
        selectionSettings: {
          selectionMode: [ej.Grid.SelectionMode.Row],
          enableToggle: true
        },
        toolbarSettings: {
          showToolbar: true,
          customToolbarItems: ['Ad_Chart']
        },
        columns: childGridColumns,
        actionComplete: function (args) {
          if (args.requestType === 'refresh') {
            const $toolbar = $('#' + this._id + '_toolbarItems');
            const li = $('#' + this._id + '_Ad_Chart');
            $toolbar.ejToolbar('disableItem', li);
          }
        },
        toolbarClick: function (args) {
          const tbarObj = $(args.target);
          const rec = this.getSelectedRecords();
          const pid = rec[0].pid;
          const aid = rec[0].aid;
          if (tbarObj.hasClass('Ad_Chart')) {
            const adChart = getAdChart(aid, pid);
            adChartDialog.open();
            //adChart.redraw();
          }
        },
        recordClick: function (args) {
          const $toolbar = $('#' + this._id + '_toolbarItems');
          const li = $('#' + this._id + '_Ad_Chart');
          const recs = this.getSelectedRecords();
          const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
          $toolbar.ejToolbar(action, li);
        },
        create: function (args) {
          $('.Ad_Chart').parent('li').attr('title', localeStrings.statistics);
        }
      }
    }).data('ejGrid');
    const dmPie = ej.DataManager({
      url: pieURI + pieParams,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmPie2 = ej.DataManager({
      url: pie2URI + pieParams,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    /*pieQuery = new ej.Query()
     .addParams('item', options.item)
     .addParams('start', startDate)
     .addParams('end', endDate)
     .addParams('owner', options.owner)
     .addParams('period', options.period),
     pieQuery2 = new ej.Query()
     .addParams('item', options.item)
     .addParams('start', startDate)
     .addParams('end', endDate)
     .addParams('owner', options.owner)
     .addParams('period', options.period),*/
    const pieHits = $('#pieChartHits').ejChart({
      //size: {width: '250px', height: '300px'},
      title: {
        text: localeStrings.impressions,
        font: {
          fontFamily: '"Open Sans",sans-serif',
          fontWeight: 'bold',
          size: '20px'
        }
      },
      series: [{
        dataSource: dmPie,
        query: new ej.Query(),//pieQuery,
        xName: 'title',
        yName: 'hits',
        type: 'doughnut',
        tooltip: {
          format: "#point.x# : #point.y#",
          visible: true
        },
        labelPosition: 'outside',
        doughnutCoefficient: 0.4,
        marker: {
          dataLabel: {
            visible: true,
            connectorLine: {height: 20},
            font: {size: '13px'}
          }
        }
      }],
      isResponsive: true,
      legend: {visible: true}
    });
    const pieClicks = $('#pieChartClicks').ejChart({
      title: {
        text: localeStrings.clicks,
        font: {
          fontFamily: '"Open Sans",sans-serif',
          fontWeight: 'bold',
          size: '20px'
        }
      },
      series: [{
        dataSource: dmPie2,
        query: new ej.Query(),//pieQuery2,
        tooltip: {
          format: "#point.x# : #point.y#",
          visible: true
        },
        xName: 'title',
        yName: 'clicks',
        type: 'doughnut',
        marker: {
          dataLabel: {
            visible: true,
            connectorLine: {height: 20},
            font: {size: '13px'}
          }
        },
        labelPosition: 'outside'
      }],
      isResponsive: true,
      legend: {visible: true}
    });


  });
})(jQuery);
